import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { PlanMapOption } from "@modules/erpIntegrations/types";
import { PlanMapOptionFormValues } from "@modules/erpIntegrations/validations";
import { getErpErrorMessage } from "@modules/erpIntegrations/utils";

import { createPlanMapOptionService } from "./service";
import { UseCreatePlanMapOptionMutationOptions } from "./types";

export function useCreatePlanMapOptionMutation(
  options?: UseCreatePlanMapOptionMutationOptions
) {
  const { open } = useNotification();

  return useMutation<PlanMapOption, ApiError, PlanMapOptionFormValues>({
    mutationFn: createPlanMapOptionService,
    onError: (error) => {
      open?.({
        type: "error",
        message: getErpErrorMessage(error),
      });
    },
    ...options,
  });
}
